// extracted by mini-css-extract-plugin
export default {"wrapper":"iB-z","viewport":"jB-z","container":"kB-z","slide":"lB-z"};